<div class="terms-of-use-container-wrapper">
  <div class="terms-of-use-container" *ngIf="text">
    <div class="terms-of-use-body" [innerHtml]="text">
    </div>
  </div>
</div>